// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4e36699c","551":"e48e2e00","616":"2f5b9376"}[chunkId] + ".chunk.js";
};